import styled, { css } from 'styled-components';
import ChevronDown from '@panel/commons/assets/icons/ChevronDown.svg';
import ChevronUp from '@panel/commons/assets/icons/ChevronUp.svg';
import { select } from '@panel/commons/core/themev2';

const Container = styled.div`
  height: fit-content;
  width: 100%;
  background-color: #fafafa;
  @media (max-width: 768px) {
    ${({ device }) =>
      device === 'mobile' &&
      css`
        display: flex;
        align-items: center;
        height: fit-content;
      `}
  }
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Hind';
  font-style: normal;
  @media (max-width: 768px) {
    ${({ device }) =>
      device === 'mobile' &&
      css`
        margin-top: 0%;
        margin-left: 0;
        width: 100%;
      `}
  }
`;

const LogoContainer = styled.div`
  margin-top: 32px;
  width: 290px;
  display: flex;
  align-self: flex-start;
  margin-left: 2%;
  @media (min-width: 1920px) {
    margin-left: 10%;
  }
  @media (max-width: 1440px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        margin-left: 0;
        margin-top: 0;
      `}
  }
  @media (max-width: 768px) {
    ${({ device }) =>
      device === 'mobile' || device === 'tablet'
        ? css`
            width: 60%;
            margin-top: 26px;
            align-self: center;
            margin-left: 10%;
          `
        : null}
  }
`;

const Logo = styled.img`
  margin-left: 0;
  margin-top: '10%';
  @media (max-width: 1440px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        margin-top: 48px;
        margin-left: 80px;
      `}
  }
  @media (max-width: 820px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        margin-left: 42px;
        margin-bottom: 32px;
      `}
  }
  @media (max-width: 768px) {
    ${({ device }) =>
      device === 'mobile' || device === 'tablet'
        ? css`
            margin-left: 10%;
            width: 56%;
            margin-bottom: 32px;
            margin-top: 0;
          `
        : null}
  }
`;

const CardsCotainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 2%;
  margin-right: 2%;
  margin-top: 1.5%;
  margin-bottom: 2%;
  width: 96%;
  align-self: flex-start;
  @media (min-width: 1920px) {
    margin-left: 10%;
    margin-right: 10%;
    width: 80%;
  }
  @media (max-width: 1440px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        margin-left: 80px;
        margin-right: 80px;
        width: 86%;
      `}
  }
  @media (max-width: 820px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        display: none;
      `}
  }
`;

const CardContainer = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  &:first-child {
    margin-left: 0;
  }
  @media (max-width: 1440px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        display: none;
      `}
  }
  @media (max-width: 820px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        margin-right: 0%;
        margin-top: 26px;
        margin-bottom: 0%;
        width: 90%;
        display: flex;
        flex-direction: column;
      `}
  }
  @media (max-width: 768px) {
    ${({ device }) =>
      device === 'mobile' &&
      css`
        width: 90%;
        margin-right: 0%;
        margin-bottom: 0%;
      `};
  }
`;

const CardTitle = styled.h4`
  font-weight: 600;
  font-size: 20px;
  line-height: 130%;
  font-style: normal;
  color: ${select('black')};
  margin-bottom: 16px;
  margin-top: ${props => (props.marginTop ? '25px' : '0px')};
  @media (max-width: 768px) {
    ${({ device }) =>
      device === 'mobile' &&
      css`
        font-weight: 400;
        font-size: 16px;
        line-height: 25.62px;
        width: 100%;
        margin-top: 4%;
        margin-bottom: 10px;
      `}
  }
`;

const CardLinks = styled.a`
  text-decoration: none;
  font-weight: 400;
  font-family: 'Hind';
  font-size: 14px;
  line-height: normal;
  font-style: normal;
  color: ${select('black')};
  margin-bottom: 1%;
  @media (max-width: 768px) {
    ${({ device }) =>
      device === 'mobile' &&
      css`
        display: flex;
        flex-direction: column;
        font-size: 12px;
        font-weight: 300;
      `}
  }
`;

const SocialMediaLink = styled.a`
  text-decoration: none;
  display: flex;
  align-items: space-around;
  margin-left: 4%;
  &:first-child {
    margin-left: 0;
  }
  @media (max-width: 768px) {
    ${({ device }) =>
      device === 'mobile' &&
      css`
        margin-top: 0%;
        margin-left: 2%;
      `}
  }
`;

const IconSocial = styled.img`
  text-decoration: none;
  @media (max-width: 768px) {
    ${({ device }) =>
      device === 'mobile' &&
      css`
        margin-top: 0%;
        width: 80%;
      `}
  }
`;

const DropDownAcordion = styled.div`
  @media (max-width: 1440px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        display: none;
      `}
  }
  @media (max-width: 820px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        display: block;
      `}
  }
  height: fit-content;
  width: 90%;
`;

const SocialLinks = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding-bottom: 8%;
  @media (max-width: 768px) {
    ${({ device }) =>
      device === 'mobile' &&
      css`
        width: auto;
        margin-top: 2%;
        padding-bottom: 0%;
      `}
  }
`;

const BottomFooterContainer = styled.div`
  width: 100%;
  background-color: #ededed;
  @media (max-width: 768px) {
    margin-top: 25px;
    height: fit-content;
  }
`;

const HeaderContainter = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const Title = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: ${select('black')};
  margin-bottom: 6px;
`;

const Chevron = styled.button`
  background-image: ${({ isOpen }) => `url(${isOpen ? ChevronUp : ChevronDown})`};
  width: 24px;
  height: 24px;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 8px;
  margin-bottom: 10px;
  align-self: flex-end;
`;

const PortalLink = styled.a`
  text-decoration: none;
  font-weight: 400;
  font-family: 'Hind';
  font-size: 14px;
  line-height: 26px;
  color: ${select('black')};
  margin: 0 4px;
`;

const PortalLinkContainer = styled.div`
  display: flex;
`;

const CardContent = styled.div`
  text-decoration: none;
  font-weight: 400;
  font-family: 'Hind';
  font-size: 14px;
  line-height: 26px;
  color: ${select('black')};
  margin-bottom: 1%;
  display: flex;
  @media (max-width: 768px) {
    ${({ device }) =>
      device === 'mobile' &&
      css`
        display: flex;
        flex-direction: column;
        font-size: 12px;
        font-weight: 300;
      `}
  }
`;

const BottomSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${select('midLightGray')};
  margin-bottom: 22px;
`;

export {
  BottomSeparator,
  PortalLink,
  CardContent,
  PortalLinkContainer,
  Container,
  Content,
  LogoContainer,
  Logo,
  CardsCotainer,
  CardContainer,
  CardTitle,
  CardLinks,
  SocialMediaLink,
  IconSocial,
  SocialLinks,
  BottomFooterContainer,
  DropDownAcordion,
  HeaderContainter,
  Title,
  Chevron
};
